<template>
  <!-- 表单项配置组件
        @author liuguisheng
        @date 2019-9-9  
  -->
  <div class="item-config">
    <template>
      <div class="component-wrap">
        <div class="title">基本组件</div>
        <draggable tag="ul" class="list-wrap"
                   :list="baseComponents"
                   :clone="(config) => makeFormNodeConfig()"
                   @end="endDraggable"
                   v-bind="{ group:{ name:'base_components', pull:'clone', put:false },
                             sort:false, ghostClass:'ghost' }">
          <li v-for="(item,index) in baseComponents" :key="index"
              :class="formExhibitsManager(item).getType()"
              :data-type="formExhibitsManager(item).getType()"
              @click="clickAddCompenent(item)">
            <i :class="['iconfont',formExhibitsManager(item).getIcon()]"></i>
            <span>{{formExhibitsManager(item).getName()}}</span>
          </li>
        </draggable>
      </div>
    </template>               
    <template>
      <div class="component-wrap">
        <div class="title">高级组件</div>
        <draggable tag="ul" class="list-wrap"
                   :list="advancedComponents"
                   :clone="(config) => makeFormNodeConfig()"
                   @end="endDraggable"
                   v-bind="{ group:{ name:'advanced_compoonents', pull:'clone', put:false },
                             sort:false, ghostClass:'ghost' }">
          <li v-for="(item,index) in advancedComponents" 
              :key="index"
              :class="formExhibitsManager(item).getType()"
              :data-type="formExhibitsManager(item).getType()"
              @click="clickAddCompenent(item)">
            <i :class="['iconfont',formExhibitsManager(item).getIcon()]"></i>
            <span>{{formExhibitsManager(item).getName()}}</span>
          </li>
        </draggable>
      </div>
    </template>
    <template>
      <div class="component-wrap">
        <div class="title">布局组件</div>
        <draggable tag="ul" class="list-wrap"
                   :list="layoutComponents"
                   :clone="(config) => makeFormNodeConfig()"
                   @end="endDraggable"
                   v-bind="{ group:{ name:'layout_components', pull:'clone', put:false },
                             sort:false, ghostClass:'ghost' }">
          <li v-for="(item,index) in layoutComponents" 
              :key="index"
              :class="formExhibitsManager(item).getType()"
              :data-type="formExhibitsManager(item).getType()"
              @click="clickAddCompenent(item)">
            <i :class="['iconfont',formExhibitsManager(item).getIcon()]"></i>
            <span>{{formExhibitsManager(item).getName()}}</span>
          </li>
        </draggable>
      </div>
    </template>

    <!-- 分组管理扩展功能 -->
    <group-item-config v-if="expandFunction === 'group'"></group-item-config>
    
  </div>
</template>

<script>
/** 展示表单项管理 ::: 
 *  @data {Array} baseComponents 基础组件列表数据
 *  @data {Array} advancedComponents 高级组件列表数据
 *  @data {Array} layoutComponents 布局组件列表数据
 */
import { baseComponents,advancedComponents,layoutComponents } from '@/assets/js/form_dictionary.js';
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from "@/mixins/rice_index/mix_rice_index_child.js";


export default {
  name: "formItemConfig",
  components: { Draggable: require('vuedraggable') },
  mixins: [ mixRiceIndexChild ],
  data () {
    return {
      // 基本组件
      baseComponents,
      // 高级组件
      advancedComponents,
      // 布局组件
      layoutComponents,
    }
  },
  methods: {
    /** 
     *  @name 点击添加组件
     *  @description 点击添加组件到拖拽区，添加的位置为当前激活的下一项
     *  @param {Object} item 添加的对象
     *  @return { void } 
     *  @author liuguisheng
     *  @version 2019-10-31
     */
    clickAddCompenent ( item ) {
      // 如果处于分组组件名称编辑状态，禁止修改模版
      if (this.domainEditManager().getOperation() === 'name') return;

      let { type } = item;
      // 表单节点对象
      let formNode = this.makeFormNodeConfig();
      // 生成表单项配置、注册到表单项字典中
      let formConfig = this.makeFormConfig(type);
      this.formConfigManager(formConfig).setId(formNode.id);
      this.formMap[formNode.id] = formConfig;
      // 获取节点要插入的列表
      let insertNodeList = this.formList;
      if (this.formListManager().hasActiveNode()) insertNodeList = this.activeList;
      // 获取节点要插入的位置
      let insertIndex = this.formListManager().getActiveIndex()+1 || insertNodeList.length;
      // 插入新节点
      insertNodeList.splice(insertIndex, 0, formNode);
      this.formListManager().refreshList();
      // 激活表单项节点
      this.formListManager().activeNode(formNode, insertNodeList);

      // 如果是栅格，默认添加列
      if (type === 'grid') {
        this.addColumn();
        this.addColumn();
      }
    },
    /** @name 结束拖拽
     *  @param {Object} e 拖拽事件参数
     *  - {Object} item 拖拽的项对象
     *  - - {Object} _underlying_vm_ 拖拽项生成的数据
     *  - {String} pullMode 拖拽表单项放置模式
     *  @author 王汝鹏
     *  @version 2019-12-20
     */
    endDraggable(e) {
      let { item, pullMode } = e;
      let { type } = item.dataset;
      let formNode = item._underlying_vm_;

      // 无效的拖拽操作
      if (!pullMode) return;
      
      // 生成表单项配置、注册到表单项字典中
      let formConfig = this.makeFormConfig(type);
      this.formConfigManager(formConfig).setId(formNode.id);
      this.formMap[formNode.id] = formConfig;
      this.formMap = {...this.formMap};

      // 如果是栅格，默认添加列
      if (type === 'grid') {
        this.addColumn();
        this.addColumn();
      }
    },
    /** @name 添加珊格列
     *  @author 王汝鹏
     *  @version 2019-09-13
     */
    addColumn() {
      // 添加 gridColumn 节点
      let columnFormNode = this.makeFormNodeConfig();
      this.activeNode.children.push(columnFormNode);
      let columnFormConfig = this.makeFormConfig('gridColumn');
      this.formConfigManager(columnFormConfig).setId(columnFormNode.id);
      this.formMap[columnFormNode.id] = columnFormConfig;
      this.formMap = {...this.formMap};
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Config/FormItemConfig.vue